// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"427":"f20cec80","718":"1a128029","794":"e2c8dcd2","952":"f5613fae","966":"4f4ffb2f","984":"a060148c"}[chunkId] + ".css";
};